import React from 'react';

/**
 * Mini-bandeau « Départ · Dépôt X » / « Retour · Dépôt X » en tête et en fin de
 * la liste d'un camion : une fausse étape, ni sélectionnable, ni déplaçable,
 * alignée sur les colonnes des étapes (heure dans la colonne ETA).
 *
 * @param {'departure'|'return'} kind
 * @param {string} depotLabel - Terme du client pour le dépôt (« Dépôt » par défaut,
 *   TOUR_PLANNING.TRUCK_ASSIGNMENTS.DEPOT_LABEL)
 * @param {string} depotName - Nom du dépôt de rattachement du camion
 * @param {string|null} time - Heure (HH:mm), null si pas encore calculée
 * @param {number} dayOffset - Jours après la date de tournée (retour après minuit)
 * @param {number|null} legMinutes - Trajet entre le dépôt et l'étape voisine
 * @param {string} [hint] - Précision quand l'heure n'est pas celle de VROOM
 * @param {number} [firstOrder] - N° de la première étape (départ)
 * @param {number} [lastOrder] - N° de la dernière étape (retour)
 */
export default function DepotRow({
  kind,
  depotLabel = 'Dépôt',
  depotName,
  time,
  dayOffset = 0,
  legMinutes,
  hint,
  firstOrder = 1,
  lastOrder,
}) {
  const isDeparture = kind === 'departure';
  const leg =
    legMinutes !== null && legMinutes !== undefined && legMinutes >= 0
      ? `${formatMinutes(legMinutes)} de route ${
          isDeparture
            ? `jusqu’à l’étape ${firstOrder}`
            : `depuis l’étape ${lastOrder}`
        }`
      : null;

  return (
    <div
      className={`ta-depot-row ta-depot-row--${kind}`}
      title={
        isDeparture
          ? `Départ (${depotLabel.toLowerCase()}) calculé par l’optimisation, non modifiable`
          : `Retour (${depotLabel.toLowerCase()}) calculé par l’optimisation, non modifiable`
      }
    >
      {/* Emplacements de la case et de la poignée : alignement sur les étapes */}
      <span
        className="agv-selection-checkbox ta-depot-row__ghost"
        aria-hidden
      />
      <span className="ta-row__handle ta-depot-row__ghost" aria-hidden>
        ⋮⋮
      </span>
      <span className="ta-row__seq ta-depot-row__icon" aria-hidden>
        ⌂
      </span>
      <span className="ta-depot-row__main">
        <span className="ta-depot-row__label">
          {isDeparture ? 'Départ' : 'Retour'} · {depotLabel}
          {depotName && ` ${depotName}`}
        </span>
        {(leg || hint) && (
          <span className="ta-depot-row__leg">
            {[leg, hint].filter(Boolean).join(' · ')}
          </span>
        )}
      </span>
      <span className="ta-row__eta ta-depot-row__time">
        {time || '—'}
        {time && dayOffset > 0 && (
          <span className="ta-row__eta-day">J+{dayOffset}</span>
        )}
      </span>
      <span className="ta-row__menu" />
    </div>
  );
}

const formatMinutes = (minutes) => {
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest ? `${hours} h ${String(rest).padStart(2, '0')}` : `${hours} h`;
};
